import React, { FunctionComponent } from "react";
import { Form, Select } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";

// MULTISELECT — pick one or more options from a dropdown.
const MultiSelect: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => (
  <Form.Item
    name={question.id}
    label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
    rules={[{ required: question.isRequired, type: "array", message: "Please select at least one option!" }]}
    className={styles.disableMultiSelectInput}
  >
    <Select mode="multiple" disabled={disabled} placeholder={question.placeholder || "Select here"} allowClear>
      {(question.options || []).map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default MultiSelect;
